<template>
    <div>
        <breadcrumb :routerList="[{to:'/personal/dealCenter',title:'待办中心'},{title:'批量修改型号经理审批'}]"/>
        <div class="h-content">
            <!-- 基本信息 -->
            <div class="h-row h-mrt0">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>基本信息</h1>
                                </div>
                                <div class="h-pieceCon2">
                                    <div class="h-formLine Yangbiao">
                                        <el-form :model="form" label-position="right" :inline="true" class="demo-ruleForm h-formbLine h-formbLine1" disabled>
                                            <el-form-item label="批次号" class="h-elformWrap-2">
                                                <el-input v-model="form.batchNo" readonly/>
                                            </el-form-item>
                                            <el-form-item label="目标型号经理" class="h-elformWrap-2">
                                                <el-input :value="form.newUserName + '（' + form.newUserCode + '）'" readonly/>
                                            </el-form-item>
                                            <el-form-item label="提交人" class="h-elformWrap-2">
                                                <el-input v-model="form.cuname" readonly/>
                                            </el-form-item>
                                            <el-form-item label="提交时间" class="h-elformWrap-2">
                                                <el-input :value="formatDate(form.cdate)" readonly/>
                                            </el-form-item>
                                            <el-form-item label="修改记录数" class="h-elformWrap-2">
                                                <el-input :value="detailList.length + ' 条'" readonly/>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 修改明细 -->
            <div class="h-row">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>修改明细</h1>
                                </div>
                                <div class="h-pieceCon2">
                                    <el-table :data="detailList" border style="width: 100%;">
                                        <el-table-column type="index" label="#" width="50"></el-table-column>
                                        <el-table-column prop="materialCode" label="物料编码" min-width="120"></el-table-column>
                                        <el-table-column prop="materialName" label="物料名称" min-width="150"></el-table-column>
                                        <el-table-column prop="cpdlName" label="产品大类" width="120"></el-table-column>
                                        <el-table-column prop="oldUserCode" label="原型号经理编码" min-width="140"></el-table-column>
                                        <el-table-column prop="oldUserName" label="原型号经理名称" min-width="140"></el-table-column>
                                        <el-table-column label="目标型号经理编码" min-width="140">
                                            <template slot-scope="scope">
                                                <span style="color: #409EFF;">{{ scope.row.newUserCode }}</span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="目标型号经理名称" min-width="140">
                                            <template slot-scope="scope">
                                                <span style="color: #409EFF;">{{ scope.row.newUserName }}</span>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 审批意见 -->
            <div class="h-row">
                <div class="h-rowIn">
                    <div class="h-rowBox">
                        <div class="h-rowCon">
                            <div class="h-pieceIn2">
                                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                    <h1>审批意见</h1>
                                </div>
                                <div class="h-pieceCon2">
                                    <div class="h-formLine Yangbiao">
                                        <el-form :model="approveForm" :rules="approveRules" ref="approveForm" label-position="right" :inline="true" class="demo-ruleForm h-formbLine h-formbLine1">
                                            <el-form-item label="审批意见" class="h-elformWrap-3" prop="approveOpinion" :required="true">
                                                <el-input v-model="approveForm.approveOpinion" placeholder="请输入审批意见"/>
                                            </el-form-item>
                                        </el-form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <viewhistory :visible.sync="showTrackDialog" v-if="showTrackDialog" :id="instid"/>

            <div class="h-txtCenter h-mrt60">
                <el-button class="h-btn h-bBtn h-bgwhite" @click="handleBack">返回</el-button>
                <el-button v-if="taskstatus === 0" class="h-btn h-bBtn h-bgred" @click="handleApprove('REJECT')">驳回</el-button>
                <el-button v-if="taskstatus === 0" class="h-btn h-bBtn h-bggreen" @click="handleApprove('PASS')">通过</el-button>
                <el-button class="el-button h-btn el-button--default" @click="handleTrack">审批跟踪</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import batchModifyManager from '@/api/chanpin/batchModifyManager';

export default {
    data() {
        return {
            form: {},
            detailList: [],
            approveForm: {
                approveOpinion: ''
            },
            instid: '',
            taskid: '',
            taskstatus: 0,
            showTrackDialog: false,
            approveRules: {
                approveOpinion: [{ required: true, message: '请输入审批意见', trigger: 'blur' }]
            }
        };
    },
    created() {
        this.taskid = this.$route.query.taskid;
        this.instid = this.$route.query.instid;
        this.taskstatus = parseInt(this.$route.query.taskstatus || '0');
        this.loadDetail();
    },
    methods: {
        formatDate(date) {
            if (!date) return '';
            return this.$util.riQi(new Date(date));
        },
        async loadDetail() {
            try {
                // 待办中心跳转时带的是 ywid 参数，值为 batchNo
                const batchNo = this.$route.query.ywid || this.$route.query.batchNo;
                if (batchNo) {
                    const res = await batchModifyManager.selectDetailByBatchNo(batchNo);
                    if (res.f && res.obj && res.obj.length > 0) {
                        this.detailList = res.obj;
                        this.form = {
                            batchNo: res.obj[0].batchNo,
                            newUserCode: res.obj[0].newUserCode,
                            newUserName: res.obj[0].newUserName,
                            cuname: res.obj[0].cuname,
                            cdate: res.obj[0].cdate
                        };
                    }
                }
            } catch (e) {
                console.error(e);
            }
        },
        async handleApprove(approveType) {
            try {
                if (approveType === 'REJECT' && !this.approveForm.approveOpinion) {
                    this.$message.error('请输入审批意见');
                    return;
                }
                if (!this.approveForm.approveOpinion) {
                    this.approveForm.approveOpinion = approveType === 'PASS' ? '通过' : '';
                }

                const data = {
                    batchNo: this.form.batchNo,
                    taskId: this.taskid,
                    instid: this.instid,
                    approveType: approveType,
                    approveOpinion: this.approveForm.approveOpinion
                };

                const res = await batchModifyManager.approve(data);
                if (res.f) {
                    this.$message.success(res.msg || '审批成功');
                    this.$store.dispatch('searchTasktotal');
                    this.$router.push({ path: '/personal/dealCenter' });
                } else {
                    this.$message.error(res.msg || '审批失败');
                }
            } catch (e) {
                console.error(e);
            }
        },
        handleTrack() {
            this.showTrackDialog = true;
        },
        handleBack() {
            this.$router.push({ path: '/personal/dealCenter' });
        }
    }
};
</script>

<style>
.Yangbiao .h-elformWrap-2 .el-form-item__label {
    width: 45%;
    text-align: right;
}

.Yangbiao .el-form-item__content {
    width: 55%;
}

.Yangbiao .h-elformWrap-2 {
    width: 25% !important;
    padding-right: 0.5rem;
}

.Yangbiao .h-elformWrap-3 {
    width: 85% !important;
    padding-right: 0.5rem;
}

.Yangbiao .h-elformWrap-3 .el-form-item__label {
    width: 12%;
    text-align: right;
}
</style>
